import { Link } from 'react-router-dom'
import { Card } from '../components/Card'

/** Fallback for unknown routes. */
export function NotFoundScreen() {
  return (
    <>
      <h1>Page not found</h1>
      <Card>
        <p>That page does not exist.</p>
        <p>
          <Link to="/today">Go to Today</Link>
        </p>
      </Card>
    </>
  )
}
